<script lang="ts">
  import {getContext} from 'svelte'
  import {popupUtil} from '@/helper/popup';
  import WalletDialog from '../../popups/WalletDialog.svelte';
  import {initWalletProps, WalletType} from './utils';
  import AccessWithWalletConnect from '@/modules/components/access-with-wallet/AccessWithWalletConnect.svelte';
  import AccessWithMetaMask from '@/modules/components/access-with-wallet/AccessWithMetaMask.svelte';

  let className = ''
  export {className as class};
  export let walletProps = initWalletProps();

  const WalletIcon = {
    WalletConnect: 'https://img.phemex.com/v1/bcb25e8c-32fe-4bbf-b1e5-d294aeb2574d/wallet-connet-rec.png',
    Metamask: 'https://img.phemex.com/v1/4ce52b03-aec4-4908-9320-dc52e255a388/metamask-rec.png'
  }
  const LLG = getContext('LG');

  let metaMaskDom, walletConnectDom;

  function handleClick(){
   const dialog = popupUtil.create(WalletDialog, {LG: LLG, metamaskIcon: WalletIcon.Metamask, walletConnectIcon: WalletIcon.WalletConnect, width: 24, walletProps});
   dialog.$on('open', function(event){
     const type = event.detail.type;
     if(type === WalletType.Metamask) {
       metaMaskDom?.handleConnectClick();
       return;
     }
     if(type === WalletType.WalletConnect) {
       walletConnectDom?.handleConnectClick();
     }
   })
  }
</script>

<style lang="scss">
  .wallet-box {
    background: #F6F7FB;
    padding: 12px 20px;
    white-space: nowrap;
    border-radius: 48px;
    color: #1d2029;
    &:hover{
      background: #E9ECF2;
    }
  }
</style>

<div class="df aic wallet-box cp {className}" on:click|stopPropagation={handleClick}>
  Connect Wallet
  <div class="ml20 df aic">
    <img width="24" height="24" src={WalletIcon.WalletConnect} alt="wallet connect"/>
    <img width="24" height="24" class="ml12" src={WalletIcon.Metamask} alt="metamask"/>
  </div>
</div>
<div class="dn party-wallet-login">
  <AccessWithMetaMask bind:this={metaMaskDom} {...walletProps} />
  <AccessWithWalletConnect bind:this={walletConnectDom} {...walletProps}/>
</div>
